import { useShallow } from 'zustand/react/shallow'
import { useCADPageStore } from '@/state'
import { Button } from '@/components/ui/button'
import { ChevronRightIcon, ChevronLeftIcon } from '@radix-ui/react-icons'

export const ToggleAssemblyTreeButton = () => {
  const setCADState = useCADPageStore(useShallow((state) => state.setState))
  const isAssemblyTreeOpen = useCADPageStore(
    (state) => state.isAssemblyTreeOpen,
  )

  return (
    <Button
      type="button"
      className="rounded-full bg-primary-10 text-primary-40 border border-primary-20 shadow-none px-0 py-0 h-7"
      onClick={() => {
        setCADState({
          isAssemblyTreeOpen: !isAssemblyTreeOpen,
        })
      }}
    >
      {isAssemblyTreeOpen ? (
        <ChevronLeftIcon className="w-6 h-6" />
      ) : (
        <ChevronRightIcon className="w-6 h-6" />
      )}
    </Button>
  )
}
